module.exports = __webpack_public_path__ + "static/labs-logo-gray-310e5201bfedd74edd55d7b7cbe2cf12.png";